export default __webpack_public_path__ + "static/media/05.ede77b66.gif";